import PropTypes from 'prop-types';
import { Button, Dialog, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import LoadingButton from '../LoadingButton/LoadingButton';

import {
  DialogActionsStyled,
  DialogContainer,
  DialogContentStyled,
  DialogImage,
  DialogText,
  DialogTitleStyled,
  PaperStyled,
} from './ActionDialog.parts';

export default function ActionDialog({
  content,
  disableBackdropClick,
  confirmationButtonText,
  hideCancel,
  showAlternateActionButton,
  alternateActionButtonText,
  handleAlternateActionButton,
  image,
  isLoading,
  maxWidth,
  open,
  title,
  buttonDisabled,
  handleConfirmation,
  handleClose,
}) {
  const { t } = useTranslation();

  return (
    <Dialog
      disableBackdropClick={disableBackdropClick}
      open={open}
      maxWidth={maxWidth}
      onClose={handleClose}
      aria-labelledby="action-dialog"
      PaperComponent={PaperStyled}
      data-testid="action-dialog-wrapper"
    >
      <DialogContainer>
        <DialogTitleStyled disableTypography={true}>
          {image && <DialogImage>{image}</DialogImage>}
          <Typography variant="h1">{title}</Typography>
        </DialogTitleStyled>
        <DialogContentStyled>
          <DialogText id="action-dialog-description">{content}</DialogText>
        </DialogContentStyled>
      </DialogContainer>
      <DialogActionsStyled>
        {!hideCancel && (
          <Button variant="contained" onClick={handleClose}>
            {t('Abbrechen')}
          </Button>
        )}
        {showAlternateActionButton && (
          <Button variant="contained" color="primary" onClick={handleAlternateActionButton}>
            {alternateActionButtonText}
          </Button>
        )}
        <LoadingButton
          variant="contained"
          color="primary"
          disabled={buttonDisabled}
          isLoading={isLoading}
          onClick={handleConfirmation}
          data-testid="action-dialog-confirm"
        >
          {confirmationButtonText || t('Ok')}
        </LoadingButton>
      </DialogActionsStyled>
    </Dialog>
  );
}

ActionDialog.defaultProps = {
  disableBackdropClick: false,
  buttonDisabled: false,
  confirmationButtonText: null,
  hideCancel: false,
  image: null,
  isLoading: false,
  maxWidth: 'sm',
  showAlternateActionButton: false,
  alternateActionButtonText: null,
  handleAlternateActionButton: null,
};

ActionDialog.propTypes = {
  content: PropTypes.oneOfType([PropTypes.node, PropTypes.elementType]).isRequired,
  buttonDisabled: PropTypes.bool,
  disableBackdropClick: PropTypes.bool,
  hideCancel: PropTypes.bool,
  image: PropTypes.oneOfType([PropTypes.node, PropTypes.elementType]),
  isLoading: PropTypes.bool,
  maxWidth: PropTypes.string,
  open: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  confirmationButtonText: PropTypes.string,
  handleConfirmation: PropTypes.func.isRequired,
  showAlternateActionButton: PropTypes.bool,
  alternateActionButtonText: PropTypes.string,
  handleAlternateActionButton: PropTypes.func,
  handleClose: PropTypes.func.isRequired,
};
